import { S as v, M as f, P as m, N as y } from "./pagination.chunk.js";
class b extends HTMLElement {
  constructor() {
    super(),
      (this.switchesContainer = this.querySelector("[data-tabs-container]")),
      (this.contentContainer = this.querySelector("[data-content-container]")),
      (this.tabSwitches = Array.from(
        this.switchesContainer.querySelectorAll("[data-tab]")
      )),
      (this.contentEntries = Array.from(
        this.contentContainer.querySelectorAll("[data-content-entry]")
      )),
      (this.tabSwitchClickedHandler = this.handleTabSwitchClicked.bind(this));
  }
  connectedCallback() {
    this.tabSwitches.forEach((n) =>
      n.addEventListener("click", this.tabSwitchClickedHandler)
    ),
      this.tabSwitches.at(0).dispatchEvent(new MouseEvent("click")),
      this.setAttribute("data-loaded", "");
  }
  handleTabSwitchClicked(n) {
    const u = n.currentTarget;
    this.contentEntries.forEach((t) => t.removeAttribute("data-active")),
      this.tabSwitches.forEach((t) => {
        t.removeAttribute("data-prev"), t.removeAttribute("data-next");
      });
    const c = this.contentEntries.find(
      (t) => t.dataset.index == u.dataset.index
    );
    c && c.setAttribute("data-active", "");
    const a = this.tabSwitches.find(
        (t) => t.dataset.index == +u.dataset.index + 1
      ),
      r = this.tabSwitches.find((t) => t.dataset.index == +u.dataset.index - 1);
    r && r.setAttribute("data-prev", ""), a && a.setAttribute("data-next", "");
  }
  disconnectedCallback() {
    this.tabSwitches.forEach((n) =>
      n.removeEventListener("click", this.tabSwitchClickedHandler)
    );
  }
}
customElements.define("info-tabs", b);
document.addEventListener("DOMContentLoaded", function () {
  function l() {
    const c = document.querySelectorAll(".ma-video-toggle"),
      a = document.getElementById("video_review_modal"),
      r = document.querySelectorAll(".video-player-button"),
      t = document.querySelector("[data-video-block-overlay]"),
      p = () => {
        a.classList.add("active"),
          document.body.classList.add("ma-overflow-hidden"),
          r.forEach((e) => {
            e.setAttribute("data-state", "active");
          });
      },
      d = () => {
        n(),
          a.classList.remove("active"),
          document.body.classList.remove("ma-overflow-hidden"),
          r.forEach((e) => {
            e.setAttribute("data-state", "inactive");
          });
      };
    t &&
      t.addEventListener("click", function () {
        d();
      }),
      c.forEach((e) => {
        e.addEventListener("click", () => {
          let s = parseInt(e.dataset.activeSlide, 10);
          a.classList.contains("active") ? d() : p(),
            window.videoReviewPopup.slideTo(s);
        });
      });
  }
  function n() {
    const c = document.querySelectorAll("[id^='main_video_popup_']");
    if (c.length == 0) return;
    const a = document.querySelector("#play-pause");
    a.getAttribute("data-state") === "play" &&
      a.setAttribute("data-state", "pause"),
      c.forEach((t, p) => {
        const d = t.closest("[data-video-block]");
        t.pause(),
          (t.currentTime = 0),
          (d.querySelector(".inner").style.width = 0),
          d.querySelector(".ma-play").classList.remove("ma-opacity-0"),
          d.querySelector(".ma-play").classList.add("ma-opacity-100");
      });
  }
  function u() {
    const c = document.querySelectorAll("[id^='main_video_popup_']");
    if (c.length === 0) return;
    const a = document.querySelector("#play-pause");
    a.addEventListener("click", function () {
      if (a.getAttribute("data-state") === "pause") {
        a.setAttribute("data-state", "play");
        let s = !1;
        c.forEach((i) => {
          i.closest(".swiper-slide-active") && !s && ((s = !0), i.play());
        });
      } else
        a.setAttribute("data-state", "pause"),
          c.forEach((s) => {
            if (!s.paused) {
              s.pause();
              const i = s.closest("[data-video-block]");
              i.querySelector(".ma-play").classList.remove("ma-opacity-0"),
                i.querySelector(".ma-play").classList.add("ma-opacity-100");
            }
          });
    }),
      c.forEach((e) => {
        const s = e.closest("[data-video-block]");
        e.addEventListener("timeupdate", () => {
          let i = (e.currentTime / e.duration) * 100;
          e.ended &&
            (a.setAttribute("data-state", "pause"),
            s.querySelector(".ma-play").classList.remove("ma-opacity-0"),
            s.querySelector(".ma-play").classList.add("ma-opacity-100")),
            i >= 99 ? (i = "100%") : (i = `${i}%`),
            (s.querySelector(".inner").style.width = i);
        }),
          s.querySelector(".ma-play").addEventListener("click", function (i) {
            e.paused
              ? (a.setAttribute("data-state", "play"),
                this.classList.add("ma-opacity-0"),
                this.classList.remove("ma-opacity-100"),
                e.play())
              : (a.setAttribute("data-state", "pause"),
                this.classList.remove("ma-opacity-0"),
                this.classList.add("ma-opacity-100"),
                e.pause());
          }),
          s
            .querySelector(".ma-timeline")
            .addEventListener("click", function (i) {
              const o = i.target.closest(".ma-timeline");
              if (o) {
                var h =
                  (i.pageX - (o.offsetLeft + o.offsetParent.offsetLeft)) /
                  o.offsetWidth;
                e.currentTime = h * e.duration;
              }
            });
      });
    const r = document.querySelectorAll("#mute");
    r.forEach((e) => {
      e.addEventListener("click", function () {
        const i = e.getAttribute("data-state") === "mute";
        c.forEach((o) => {
          o.muted = i;
        }),
          r.forEach((o) => {
            i
              ? o.setAttribute("data-state", "unmute")
              : o.setAttribute("data-state", "mute");
          });
      });
    });
    var t = document.getElementsByClassName("swiper-hover-video");
    [].forEach.call(t, function (e) {
      e.addEventListener("mouseover", p, !1),
        e.addEventListener("mouseout", d, !1);
    });
    function p(e) {
      (this.previousElementSibling.muted = !0),
        this.previousElementSibling.play(),
        this.classList.add("ma-opacity-0"),
        this.classList.add("-ma-z-10"),
        this.classList.remove("ma-opacity-100"),
        this.previousElementSibling.addEventListener("timeupdate", () => {
          this.currentTime >= 3 && (this.currentTime = 0);
        });
    }
    function d(e) {
      this.previousElementSibling.pause(),
        (this.previousElementSibling.currentTime = 0),
        this.classList.remove("ma-opacity-0"),
        this.classList.remove("-ma-z-10"),
        this.classList.add("ma-opacity-100"),
        this.previousElementSibling.removeEventListener("timeupdate", () => {});
    }
  }
  l(),
    n(),
    u(),
    document.querySelector(".video-popup:not(.swiper-initialized)") &&
      ((window.videoReviewPopup = new v(".video-popup", {
        modules: [f, m, y],
        cssMode: !0,
        navigation: {
          nextEl: ".swiper-button-next-video",
          prevEl: ".swiper-button-prev-video",
        },
        allowTouchMove: !0,
        breakpoints: { 768: { allowTouchMove: !1 } },
      })),
      window.videoReviewPopup.on("slideChange", function () {
        n();
      }));
});
document.addEventListener("DOMContentLoaded", function () {
  const l = document.querySelector("[data-swiper-gallery-thumbs]");
  if (!l) return;

  function getSwiperConfig() {
    const width = window.innerWidth;
    if (width >= 990) {
      return {
        direction: "vertical",
        slidesPerView: "auto",
        cssMode: !0,
        spaceBetween: 10,
      };
    } else if (width >= 768) {
      return { direction: "horizontal", slidesPerView: 6, spaceBetween: 10 };
    } else {
      return { direction: "horizontal", slidesPerView: 5, spaceBetween: 10 };
    }
  }

  Object.assign(l, {
    ...getSwiperConfig(),
    breakpoints: {
      768: { slidesPerView: 6, direction: "horizontal", spaceBetween: 10 },
      990: {
        direction: "vertical",
        slidesPerView: "auto",
        cssMode: !0,
        spaceBetween: 10,
      },
    },
  });

  l.initialize();

  setTimeout(() => {
    const currentConfig = getSwiperConfig();
    if (l.swiper) {
      Object.assign(l.swiper.params, currentConfig);
      l.swiper.changeDirection(currentConfig.direction, !0);
      l.swiper.update();
    }
    l.classList.add("loaded");
  }, 50);

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (l.swiper) {
        const newConfig = getSwiperConfig();
        Object.assign(l.swiper.params, newConfig);
        l.swiper.changeDirection(newConfig.direction, !0);
        l.swiper.update();
      }
    }, 100);
  });
});
